import { useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DialogContent, DialogActions } from '@mui/material';
import { useAuth } from '@app/api/auth/useAuth';
import { clearTempToken } from '@app/api/tokenService';
import { ThemeButton } from '@shared/ui/buttons';
import { CodePinInput } from '@shared/ui/forms/inputs';
import { validateServerErrors } from '@utils/validation';

export default function LoginTwofaDialog({ close }) {
  const { t } = useTranslation();
  const { loginWithTwoFa } = useAuth();
  const {
    control,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      '2fa_code': '',
    },
  });
  const twoFaCodeWatch = useWatch({ control, name: '2fa_code' });

  useEffect(() => clearTempToken, []);

  async function onSubmit(data) {
    try {
      const res = await loginWithTwoFa(data);
      if (res) close();
    } catch (err) {
      validateServerErrors(setError, err);
    }
  }

  return (
    <>
      <DialogContent className="twoFa">
        <CodePinInput
          control={control}
          name="2fa_code"
          error={errors['2fa_code']}
          label={t('enter_2fa_code')}
        />
      </DialogContent>
      <DialogActions>
        <ThemeButton
          onClick={handleSubmit(onSubmit)}
          startIcon="check"
          loading={isSubmitting}
          disabled={twoFaCodeWatch.length < 6}
        >
          {t('submit')}
        </ThemeButton>
      </DialogActions>
    </>
  );
}
